import { ChartConfig } from "@/components/ui/chart";

export const chartConfig = {
  views: {
    label: "Views",
  },
} satisfies ChartConfig;
